module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "700",
      "content-class": "service-extension-dialog",
      "persistent": true
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-snackbar', {
    attrs: {
      "timeout": _vm.snackbar.timeout,
      "top": "",
      "color": _vm.snackbar.color,
      "rounded": "",
      "centered": ""
    },
    model: {
      value: (_vm.snackbar.show),
      callback: function($$v) {
        _vm.$set(_vm.snackbar, "show", $$v)
      },
      expression: "snackbar.show"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbar.text) + "\n  ")]), _vm._v(" "), _c('v-card', {
    staticClass: "dialog-card"
  }, [_c('v-card-title', {
    staticClass: "service-extension-dialog-title text-break mb-0 mt-0 text-center justify-center",
    attrs: {
      "tag": "p"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "10",
      "offset": "1"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('ServiceExtensionDialog.title')) + "\n        ")]), _vm._v(" "), _c('v-col', {
    staticClass: "px-0 text-end",
    attrs: {
      "cols": "1",
      "align-self": "start"
    }
  }, [_c('v-btn', {
    staticClass: "my-0",
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#000000"
    }
  }, [_vm._v("close")])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.step === _vm.steps.queryServiceExtension && _vm.pendingServiceExtensions && _vm.pendingServiceExtensions.length > 0) ? [_c('v-card-text', [_c('v-row', {
    staticClass: "my-2",
    attrs: {
      "justify": "center"
    }
  }, [_c('p', {
    staticClass: "text-center service-extension-dialog-hint mb-0"
  }, [_c('v-icon', {
    staticClass: "service-extension-icon",
    attrs: {
      "size": "1rem"
    }
  }, [_vm._v("mdi-clock-outline")]), _vm._v(_vm._s(_vm.$t('ServiceExtensionDialog.serviceEndsOn', {
    deviceName: _vm.device.campaign.entityName,
    date: _vm.formatEndDate(_vm.device.serviceEndDate)
  })) + "\n          ")], 1)]), _vm._v(" "), _c('v-row', {
    staticClass: "mt-2",
    attrs: {
      "justify": "center"
    }
  }, [_c('p', {
    staticClass: "text-center service-extension-dialog-pending-title"
  }, [_vm._v(_vm._s(_vm.$t('ServiceExtensionDialog.pendingServiceExtensionTitle')))])]), _vm._v(" "), _c('v-row', {
    staticClass: "mt-2",
    attrs: {
      "justify": "center"
    }
  }, [_c('p', {
    staticClass: "text-center service-extension-dialog-pending-detail"
  }, [_vm._v(_vm._s(_vm.$t('ServiceExtensionDialog.pendingServiceExtensionDetail', {
    date: _vm.formatEndDate(_vm.pendingServiceExtensions[0].newServiceEndDate),
    userName: _vm.getUserName(_vm.pendingServiceExtensions[0].createdBy.id, _vm.pendingServiceExtensions[0].createdBy.name)
  })))])]), _vm._v(" "), _c('v-row', {
    staticClass: "mt-2",
    attrs: {
      "justify": "center"
    }
  }, [_c('p', {
    staticClass: "text-center service-extension-dialog-pending-description"
  }, [_vm._v(_vm._s(_vm.$t('ServiceExtensionDialog.pendingServiceExtensionDescription')))])])], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "justify-center mb-5"
  }, [_c('v-btn', {
    staticClass: "submit-button",
    attrs: {
      "depressed": "",
      "color": "#0098E1",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.accept()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('ServiceExtensionDialog.accept')) + "\n        ")])], 1)] : (_vm.step === _vm.steps.queryServiceExtension) ? _c('v-form', {
    ref: "form",
    model: {
      value: (_vm.isFormValid),
      callback: function($$v) {
        _vm.isFormValid = $$v
      },
      expression: "isFormValid"
    }
  }, [_c('v-card-text', [_c('v-row', {
    staticClass: "my-2",
    attrs: {
      "justify": "center"
    }
  }, [_c('p', {
    staticClass: "text-center service-extension-dialog-hint mb-0"
  }, [_c('v-icon', {
    staticClass: "service-extension-icon",
    attrs: {
      "size": "1rem"
    }
  }, [_vm._v("mdi-clock-outline")]), _vm._v(_vm._s(_vm.$t('ServiceExtensionDialog.serviceEndsOn', {
    deviceName: _vm.device.campaign.entityName,
    date: _vm.formatEndDate(_vm.device.serviceEndDate)
  })) + "\n          ")], 1)]), _vm._v(" "), _c('v-row', {
    staticClass: "mt-2",
    attrs: {
      "justify": "center"
    }
  }, [_c('p', {
    staticClass: "text-center service-extension-dialog-subtitle"
  }, [_vm._v(_vm._s(_vm.$t('ServiceExtensionDialog.queryNewServiceEndDate')))])]), _vm._v(" "), _c('v-row', {
    staticClass: "mt-2",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "8",
      "md": "6"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          staticClass: "pt-0",
          attrs: {
            "label": ("" + (_vm.$t('ServiceExtensionDialog.serviceEndDate'))),
            "title": _vm.$t('ServiceExtensionDialog.serviceEndDate'),
            "readonly": "",
            "persistent-hint": "",
            "flat": "",
            "color": "#0098E1",
            "clearable": "",
            "prepend-icon": "mdi-calendar",
            "rules": [_vm.rules.fieldRequired, _vm.rules.validateNewServiceEndDate],
            "hide-details": "auto"
          },
          model: {
            value: (_vm.newServiceEndDate),
            callback: function($$v) {
              _vm.newServiceEndDate = $$v
            },
            expression: "newServiceEndDate"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.serviceEndDateMenu),
      callback: function($$v) {
        _vm.serviceEndDateMenu = $$v
      },
      expression: "serviceEndDateMenu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "color": "#0098E1",
      "locale": "es-AR",
      "min": _vm.getCurrentDate()
    },
    on: {
      "change": function($event) {
        return _vm.formatDate($event)
      }
    },
    model: {
      value: (_vm.auxNewServiceEndDate),
      callback: function($$v) {
        _vm.auxNewServiceEndDate = $$v
      },
      expression: "auxNewServiceEndDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "justify-center mb-5"
  }, [_c('v-btn', {
    staticClass: "submit-button",
    attrs: {
      "depressed": "",
      "color": "#0098E1",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('ServiceExtensionDialog.submit')) + "\n        ")])], 1)], 1) : (_vm.step === _vm.steps.confirmServiceExtension) ? [_c('v-card-text', [_c('div', {
    staticClass: "text-center mt-2 mb-2"
  }, [_c('p', {
    staticClass: "service-extension-dialog-confirm-subtitle mb-0 d-inline-flex align-center"
  }, [_c('v-img', {
    staticClass: "mr-2",
    attrs: {
      "src": require('@/assets/icons/check.png'),
      "max-width": "1.15rem",
      "max-height": "1.15rem"
    }
  }), _vm._v("\n            " + _vm._s(_vm.$t('ServiceExtensionDialog.serviceExtensionReceived')) + "\n          ")], 1)]), _vm._v(" "), _c('v-row', {
    staticClass: "mt-2",
    attrs: {
      "justify": "center"
    }
  }, [_c('p', {
    staticClass: "text-center service-extension-dialog-confirm-text"
  }, [_vm._v(_vm._s(_vm.$t('ServiceExtensionDialog.serviceExtensionReceivedSubtitle')))])])], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "justify-center mb-5"
  }, [_c('v-btn', {
    staticClass: "submit-button",
    attrs: {
      "depressed": "",
      "color": "#0098E1",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.accept()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('ServiceExtensionDialog.accept')) + "\n        ")])], 1)] : (_vm.step === _vm.steps.dateWithinPeriod) ? [_c('v-card-text', [_c('div', {
    staticClass: "text-center mt-2 mb-2"
  }, [_c('p', {
    staticClass: "service-extension-dialog-confirm-subtitle mb-0 d-inline-flex align-center"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('ServiceExtensionDialog.dateWithinPeriod')) + "\n          ")])]), _vm._v(" "), _c('v-row', {
    staticClass: "mt-4",
    attrs: {
      "justify": "center"
    }
  }, [_c('p', {
    staticClass: "text-center service-extension-dialog-within-period-description"
  }, [_vm._v(_vm._s(_vm.$t('ServiceExtensionDialog.dateWithinPeriodSubtitle')))])])], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "justify-center mb-5"
  }, [_c('v-btn', {
    staticClass: "submit-button",
    attrs: {
      "depressed": "",
      "color": "#0098E1",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.accept()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('ServiceExtensionDialog.accept')) + "\n        ")])], 1)] : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e735d3f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Campaigns/ServiceExtensionDialog.vue
// module id = 1721
// module chunks = 0